import DownloadIcon from '@mui/icons-material/Download'
import VisibilityIcon from '@mui/icons-material/Visibility'
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { GlobalVariablesContext } from 'common/providers/GlobalVariablesProvider'
import { useContext, useState } from 'react'
import { blobDownload, downloadFile } from '../libs/FilesHelper'
import { MimeTypes } from '../libs/MimeTypes'
import DocumentViewer from './DocumentViewer'

const ListItemDocument = ({ documento }) => {
  const { IS_GOTTENBERG_ACTIVE } = useContext(GlobalVariablesContext)

  const { nombre, fecha_grabacion, extension, tipo, token } = documento

  const [loading, setLoading] = useState(false)

  const MimeIcon = MimeTypes[extension] || MimeTypes.default

  const { handleModal } = useContext(CustomModalContext)
  const viewDocument = () => {
    handleModal({
      enabled: true,
      closable: true,
      type: ModalTypes.Custom,
      content: <DocumentViewer token={token} title={nombre} />,
    })
  }

  const getBgColorMimeType = (extension) => {
    switch (extension) {
      case 'pdf':
        return 'red'
      case 'doc':
      case 'docx':
        return 'blue'
      case 'xls':
      case 'xlsx':
        return 'green'
      case 'txt':
        return 'dimgray'
      default:
        return 'primary.main'
    }
  }

  const getChipTipoDocumento = (tipo_documento) => {
    const color = 'warning'

    return (
      <Box sx={{ p: '0px', display: 'flex', alignItems: 'center' }}>
        <Chip label={tipo_documento} color={color} size="small" />
      </Box>
    )
  }

  return (
    <ListItem
      secondaryAction={
        <>
          <Grid container spacing={0}>
            <Button
              startIcon={loading ? <CircularProgress size={24} /> : <DownloadIcon />}
              color="primary"
              onClick={async () => {
                setLoading((prev) => !prev)
                const fichero = await downloadFile(token)

                if (fichero)
                  blobDownload(fichero.fichero, fichero.mime_type, fichero.nombre_archivo)
                setLoading((prev) => !prev)
              }}
            >
              DESCARGAR
            </Button>
            {IS_GOTTENBERG_ACTIVE && (
              <Button startIcon={<VisibilityIcon />} onClick={viewDocument}>
                VER
              </Button>
            )}
          </Grid>
        </>
      }
    >
      <ListItemAvatar sx={{ color: getBgColorMimeType(extension) }}>
        <MimeIcon weight="fill" size={40} />
      </ListItemAvatar>
      <ListItemText
        primary={nombre}
        secondary={
          <>
            {getChipTipoDocumento(tipo)}
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body2"
              color="text.primary"
            >
              {fecha_grabacion}
            </Typography>
          </>
        }
      />
    </ListItem>
  )
}

export default ListItemDocument
